import React from "react"
import Routes from "src/routes/routes"

function App() {
  return <Routes />
}

export default App
